import { NgModule } from '@angular/core';
import { PreloadAllModules, RouterModule, Routes } from '@angular/router';

import { AuthGuard } from './guards/auth/auth.guard'; // Auth-Dashboard Auth Guard

const routes: Routes = [
  { path: '', redirectTo: 'dashboard', pathMatch: 'full'},

  {
    path: 'login',
    loadChildren: () => import('./pages/login/login.module').then( m => m.LoginPageModule)
  },
  {
    path: 'register',
    loadChildren: () => import('./pages/register/register.module').then( m => m.RegisterPageModule)
  },
  {
    path: 'dashboard',
    loadChildren: () => import('./pages/dashboard/dashboard.module').then( m => m.DashboardPageModule),
  },
  {
    path: 'forgot-password',
    loadChildren: () => import('./pages/forgot-password/forgot-password.module').then( m => m.ForgotPasswordPageModule)
  },
  {
    path: 'reset-password',
    loadChildren: () => import('./pages/reset-password/reset-password.module').then( m => m.ResetPasswordPageModule)
  },
  {
    path: 'password-reset-sent',
    loadChildren: () => import('./pages/password-reset-sent/password-reset-sent.module').then( m => m.PasswordResetSentPageModule)
  },
  {
    path: 'reset-password-success',
    loadChildren: () => import('./pages/reset-password-success/reset-password-success.module').then( m => m.ResetPasswordSuccessPageModule)
  },
  {
    path: 'auth-dashboard',
    loadChildren: () => import('./pages/auth-dashboard/auth-dashboard.module').then( m => m.AuthDashboardPageModule),
    canLoad: [AuthGuard]
  },
  {
    path: 'settings',
    loadChildren: () => import('./pages/settings/settings.module').then( m => m.SettingsPageModule),
  },
  {
    path: 'game-reports',
    loadChildren: () => import('./pages/game-reports/game-reports.module').then( m => m.GameReportsPageModule)
  },
  {
    path: 'lists',
    loadChildren: () => import('./pages/lists/lists.module').then( m => m.ListsPageModule)
  },
  {
    path: 'view-lines',
    loadChildren: () => import('./pages/view-lines/view-lines.module').then( m => m.ViewLinesPageModule)
  },
  {
    path: 'enter-lines',
    loadChildren: () => import('./pages/enter-lines/enter-lines.module').then( m => m.EnterLinesPageModule)
  },
  {
    path: 'enter-player-modal',
    loadChildren: () => import('./modals/enter-player-modal/enter-player-modal.module').then( m => m.EnterPlayerModalPageModule)
  },
  {
    path: 'publish-lines-modal',
    loadChildren: () => import('./modals/publish-lines-modal/publish-lines-modal.module').then( m => m.PublishLinesModalPageModule)
  },
  {
    path: 'add-game-modal',
    loadChildren: () => import('./modals/add-game-modal/add-game-modal.module').then( m => m.AddGameModalPageModule)
  },
  {
    path: 'game-info',
    loadChildren: () => import('./pages/game-info/game-info.module').then( m => m.GameInfoPageModule)
  },
  {
    path: 'add-scratch-modal',
    loadChildren: () => import('./modals/add-scratch-modal/add-scratch-modal.module').then( m => m.AddScratchModalPageModule)
  },
  {
    path: 'eula',
    loadChildren: () => import('./pages/eula/eula/eula.module').then( m => m.EulaPageModule)
  },
  {
    path: "**",
    redirectTo: 'dashboard'
  },
  {
    path: 'biometric-setup',
    loadChildren: () => import('./modals/biometric-setup-modal/biometric-setup-modal.module').then( m => m.BiometricSetupModalPageModule)
  },
  {
    path: 'verify-login-modal',
    loadChildren: () => import('./modals/verify-login-modal/verify-login-modal.module').then( m => m.VerifyLoginModalPageModule)
  },
  {
    path: 'dual-auth-modal',
    loadChildren: () => import('./modals/dual-auth-modal/dual-auth-modal.module').then( m => m.DualAuthModalPageModule)
  },
  {
    path: 'add-notes-modal',
    loadChildren: () => import('./modals/add-notes-modal/add-notes-modal.module').then( m => m.AddNotesModalPageModule)
  },
  {
    path: 'player-info-modal',
    loadChildren: () => import('./modals/player-info-modal/player-info-modal.module').then( m => m.PlayerInfoModalPageModule)
  },
  {
    path: 'quick-report-modal',
    loadChildren: () => import('./modals/quick-report-modal/quick-report-modal.module').then( m => m.QuickReportModalPageModule)
  },
  {
    path: 'powerplay-summaries-modal',
    loadChildren: () => import('./modals/powerplay-summaries-modal/powerplay-summaries-modal.module').then( m => m.PowerplaySummariesModalPageModule)
  },
  {
    path: 'list-modal',
    loadChildren: () => import('./modals/list-modal/list-modal.module').then( m => m.ListModalPageModule)
  },
  {
    path: 'add-player-modal',
    loadChildren: () => import('./modals/add-list-player-modal/add-list-player-modal.module').then( m => m.AddListPlayerModalPageModule)
  }

];


@NgModule({
  imports: [
    RouterModule.forRoot(routes, { preloadingStrategy: PreloadAllModules, useHash: true }),
  ],
  exports: [RouterModule]
})
export class AppRoutingModule {}
